<script setup>
import { ROI_COMPARISON_COLORS, useRoiComparisonFormat } from '@/composables/roi-comparison'

const MAX_VISIBLE = 4

defineProps({
  type: {
    type: Number,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
})

const { itemAvatar, itemInitials } = useRoiComparisonFormat()
</script>

<template>
  <div class="row no-wrap roi-avatar-stack">
    <q-avatar
      v-for="item in items.slice(0, MAX_VISIBLE)"
      :key="item.id"
      size="sm"
      :color="ROI_COMPARISON_COLORS.ACCENT"
      text-color="primary"
      class="roi-avatar-stack__item"
    >
      <span class="text-weight-bold roi-avatar-stack__initials">{{ itemInitials(type, item) }}</span>
      <q-img
        v-if="itemAvatar(item)"
        no-spinner
        class="absolute-full"
        :src="itemAvatar(item)"
      />
    </q-avatar>
  </div>
</template>

<style scoped>
.roi-avatar-stack__item {
  border: .125rem solid #fff;
}
.roi-avatar-stack__initials {
  font-size: .625rem;
}
.roi-avatar-stack__item + .roi-avatar-stack__item {
  margin-left: -.5rem;
}
</style>
